import React, { useState } from "react";
import { X } from "lucide-react";

const BlogTitleForm = ({ onSubmit, onCancel }) => {
    const [formData, setFormData] = useState({
        title: "",
        sourceUrl: "",
        metaTitle: "",
        metaDescription: "",
        keywords: "",
        ogTitle: "",
        ogDescription: "",
        ogImage: "",
        canonicalUrl: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Convert keywords string to array
        const submitData = {
            ...formData,
            keywords: formData.keywords
                .split(",")
                .map((k) => k.trim())
                .filter(Boolean),
        };
        onSubmit(submitData);
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                <div className="p-6">
                    <div className="flex justify-between items-start mb-6">
                        <h2 className="text-2xl font-bold">
                            Add New Blog Title
                        </h2>
                        <button
                            onClick={onCancel}
                            className="text-gray-500 hover:text-gray-700"
                        >
                            <X className="h-6 w-6" />
                        </button>
                    </div>

                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <label
                                htmlFor="title"
                                className="block text-sm font-medium text-gray-700 mb-1"
                            >
                                Title *
                            </label>
                            <input
                                type="text"
                                id="title"
                                name="title"
                                required
                                value={formData.title}
                                onChange={handleChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>

                        <div>
                            <label
                                htmlFor="sourceUrl"
                                className="block text-sm font-medium text-gray-700 mb-1"
                            >
                                Source URL *
                            </label>
                            <input
                                type="url"
                                id="sourceUrl"
                                name="sourceUrl"
                                required
                                value={formData.sourceUrl}
                                onChange={handleChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>

                        <div>
                            <label
                                htmlFor="metaTitle"
                                className="block text-sm font-medium text-gray-700 mb-1"
                            >
                                Meta Title
                            </label>
                            <input
                                type="text"
                                id="metaTitle"
                                name="metaTitle"
                                value={formData.metaTitle}
                                onChange={handleChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>

                        <div>
                            <label
                                htmlFor="metaDescription"
                                className="block text-sm font-medium text-gray-700 mb-1"
                            >
                                Meta Description
                            </label>
                            <textarea
                                id="metaDescription"
                                name="metaDescription"
                                value={formData.metaDescription}
                                onChange={handleChange}
                                rows="3"
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>

                        <div>
                            <label
                                htmlFor="keywords"
                                className="block text-sm font-medium text-gray-700 mb-1"
                            >
                                Keywords (comma-separated)
                            </label>
                            <input
                                type="text"
                                id="keywords"
                                name="keywords"
                                value={formData.keywords}
                                onChange={handleChange}
                                placeholder="keyword1, keyword2, keyword3"
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>

                        <div>
                            <label
                                htmlFor="ogTitle"
                                className="block text-sm font-medium text-gray-700 mb-1"
                            >
                                Open Graph Title
                            </label>
                            <input
                                type="text"
                                id="ogTitle"
                                name="ogTitle"
                                value={formData.ogTitle}
                                onChange={handleChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>

                        <div>
                            <label
                                htmlFor="ogDescription"
                                className="block text-sm font-medium text-gray-700 mb-1"
                            >
                                Open Graph Description
                            </label>
                            <textarea
                                id="ogDescription"
                                name="ogDescription"
                                value={formData.ogDescription}
                                onChange={handleChange}
                                rows="3"
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>

                        <div>
                            <label
                                htmlFor="ogImage"
                                className="block text-sm font-medium text-gray-700 mb-1"
                            >
                                Open Graph Image URL
                            </label>
                            <input
                                type="url"
                                id="ogImage"
                                name="ogImage"
                                value={formData.ogImage}
                                onChange={handleChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>

                        <div>
                            <label
                                htmlFor="canonicalUrl"
                                className="block text-sm font-medium text-gray-700 mb-1"
                            >
                                Canonical URL
                            </label>
                            <input
                                type="url"
                                id="canonicalUrl"
                                name="canonicalUrl"
                                value={formData.canonicalUrl}
                                onChange={handleChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>

                        <div className="flex justify-end gap-3 pt-4">
                            <button
                                type="button"
                                onClick={onCancel}
                                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            >
                                Add Blog Title
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default BlogTitleForm;
